const DialogCityModelEnum = {
  QueryAllCities: 'QueryAllCities',
  QueryCustomerCities: 'QueryCustomerCities',
};

export default DialogCityModelEnum;
